<template>
  <div class="loadPage">
    <p>加载中… 遇到地震请牢记：</p>
    <div class="load-img-box">
      <div class="imgdiv">
        <img :class="{'show': index%3 === 0}" src="../assets/img/welpage/loading1.png" alt="">
        <img :class="{'show': index%3 === 1}" src="../assets/img/welpage/loading2.png" alt="">
        <img :class="{'show': index%3 === 2}" src="../assets/img/welpage/loading3.png" alt="">
      </div>

      <div class="textcontent">
        <div :class="{tip:true,tiphover:index%3 === 0}">伏地</div>
        <div :class="{tip:true,tiphover:index%3 === 1}">掩护</div>
        <div :class="{tip:true,tiphover:index%3 === 2}">抓牢</div>
      </div>
    </div>


  </div>
</template>

<script>
export default {
  name: 'loadPage',
  props: {
  },
  data () {
    return {
      couldClick: true,
      index: 0
    }
  },
  mounted () {
    let time = null
    time = setInterval(() => {
      this.index++
      if (this.index > 30) {
        clearInterval(time)
      }
    }, 1000)
  },
  methods: {}
}
</script>

<style lang="scss">
  @function rem($px) {
    @return $px*(1/40)*1rem;
  }
  $animationTime: 0.6s;

  .loadPage{
    position: fixed;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    z-index: 9999;
    opacity: 1;
    background: linear-gradient(180deg, #5F96FF 0%, #192346 100%);
    p{
      color: #fff;
      width: 100%;
      text-align: center;
      margin-top: rem(187);
      font-size: rem(17);
      font-family: STHeitiSC-Medium, STHeitiSC;
      font-weight: 500;
      color: #FFFFFF;
      line-height: rem(18);
      letter-spacing: 1px;
    }
    &.fade-leave-to{
      opacity: 0;
    }
    &.fade-leave-active{
      transition: opacity $animationTime;
    }

    .load-img-box{
      margin-top: rem(103);

      .imgdiv{
        display: flex;
        justify-content: center;
        width: 100%;
      }
      img{
        width: rem(154);
        height: rem(154);
        margin-right: rem(24);
        transform: translateY(0);
        transition: transform 0.3s;
        &.show{
          transform: translateY(rem(-36));
        }
      }
      img:nth-child(1){
        margin-left: rem(24);
      }
    }
    .textcontent{
      width: 100%;
      text-align: center;
      display: flex;
      justify-content: center;
      div{
        display: inline-block;
        margin-right: rem(24);
        text-align: center;
        width: rem(154);
        height: rem(28);
      }
      div:nth-child(1){
        margin-left: rem(24);

      }
    }
    .tip{
      margin-top: rem(40);
      font-size: rem(28);
      font-weight: 500;
      color: #FFFFFF;
      line-height: rem(28);
      letter-spacing: 1px;
      text-align: center;
    }
    .tiphover{
      color: #5B90F6;
      text-align: center;
    }
  }
</style>
